import * as React from 'react'
import { SVGProps } from 'react'

const SvgPocketSquares = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" {...props}>
    <path d="m17.69 10.466 1.045 1.045-7.225 7.224-1.045-1.045 7.225-7.224Zm-15.403 0-1.034 1.033 7.225 7.225 1.034-1.034-7.225-7.225Zm7.225-8.178L8.49 1.265 1.265 8.49l1.022 1.023 7.225-7.225ZM2.763 9.989l7.225 7.225 7.225-7.225-7.225-7.225L2.763 9.99Zm17.063-.407-.627-.627-1.033 1.034 1.044 1.045.616-.616a.591.591 0 0 0 0-.836Zm-2.137-.07 1.034-1.033-7.225-7.225-1.033 1.034 7.224 7.225ZM.788 8.968l-.615.615a.591.591 0 0 0 0 .836l.604.605 1.034-1.034L.788 8.967ZM8.954 19.2l.627.627a.59.59 0 0 0 .836 0l.616-.616-1.045-1.045L8.954 19.2ZM11.022.778l-.605-.604a.591.591 0 0 0-.836 0l-.615.615L9.988 1.81 11.022.778Z" />
  </svg>
)

export default SvgPocketSquares
